import { EndPointDoc, Method } from '../apiref/apireftypes';
import { ApiRef } from '../fasades/apiref';
import { GenCodeCurl } from '../apiref/genCodeCurl';
import { GenCodeJavaScript } from '../apiref/genCodeJavaScript';
import { GenCodePython } from '../apiref/genCodePython';

export function deleteModel() : EndPointDoc
{
    const desc = <>
        <p>Delete a model that you have created. This permanently removes the model from your account.</p>
        <p><strong>Note:</strong> You can only delete models that you have created yourself. The standard base models (like Llama-3.1-8b or DeepSeek-R1-8b) are read-only and cannot be deleted.</p>
    </>;

    const modelId = <>
        <p>The model identifier or model name to delete. This can be either:</p>
        <ul>
            <li>The <code>id</code> field from the model object returned by the <a href="/apiref/list-models">List Models</a> endpoint</li>
            <li>The <code>name</code> field from the model object</li>
        </ul>
        <p><strong>Important:</strong> If you are using model name, the value must be properly URL-encoded when used in the URL path. For example, if your model name is "My Custom Model", it should be encoded as <code>My%20Custom%20Model</code> (spaces become <code>%20</code>). Most HTTP libraries and tools handle URL encoding automatically, but when constructing URLs manually, use <code>encodeURIComponent()</code> in JavaScript or equivalent functions in other languages.</p>
    </>;

    const responseType = ApiRef.getType("DeleteModelResponse");

    const exampleUrl     = "v1/models/MyCustomModel";
    const genCurl        = new GenCodeCurl(Method.Delete, exampleUrl);
    const genPython      = new GenCodePython(Method.Delete, exampleUrl);
    const genJavaScript  = new GenCodeJavaScript(Method.Delete, exampleUrl);
    const codeCurl       = genCurl.generate();
    let codePython       = genPython.generateImport();
    codePython          += genPython.generateRequest();
    codePython          += genPython.readResponse();
    let codeJavaScript   = genJavaScript.generateRequest();
    codeJavaScript      += genJavaScript.readResponse();

    return {
        "title"          : "Delete Model",
        "method"         : Method.Delete,
        "url"            : "v1/models/{model-id}",
        "docurl"         : "delete-model",
        "description"    : desc,
        "seoDescription" : "Permanently delete a custom AI model.",
        "parameters"     : [
            {
                "name"        : "model-id",
                "type"        : "string",
                "description" : modelId,
                "optional"    : false
            }
        ],
        "examples" : [
            {
                "url"            : exampleUrl,
                "responseType"   : responseType,
                "output"         : [{
                    "id" : "mycustommodel",
                    "message" : "model has been deleted"
                }],
                "codeCurl"       : codeCurl,
                "codePython"     : codePython,
                "codeJavaScript" : codeJavaScript
            }
        ]
    };
}

